import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/handler-verifizierungsprozess/")({
  head: () => routeHead("/de/handler-verifizierungsprozess/"),
  beforeLoad: () => {
    throw redirect({ href: "/incredere/verificare-dealeri", statusCode: 301, replace: true });
  },
});
